<template>
  <transition name="product">
    <div class="ClueQuery">
      <van-nav-bar
        fixed
        title="我的线索"
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
      <div class="list">
        <b-col cols="12" v-for="(item, index) in cluelist" :key="index">
          <b-card
            style="width: 95%; margin: 0 auto"
            class="mt-3 card-icon-bg card-icon-bg-primary o-hidden"
            @click="onItemClick(item)"
          >
            <div class="content d-flex van-row--justify-space-between">
              <p class="card-title text-break">{{ item.projectName }}</p>
              <div class="d-flex card-title" style="align-items: center">
                <van-tag
                  class="parmary-color text-nowrap"
                  style="margin: 0 10px"
                >
                  {{ item.statusDescription }}
                </van-tag>
                <van-tag
                  class="parmary-color text-nowrap"
                  v-if="!isBusinessUser()"
                >
                  {{ item.isGetMoney }}
                </van-tag>
              </div>
            </div>
            <div class="d-flex justify-content-between fontSize">
              <span>企业名称：{{ item.companyName }}</span>
            </div>
            <div class="d-flex justify-content-between fontSize">
              <span>所属行业：{{ item.canye }}</span>
            </div>
            <div class="d-flex justify-content-between fontSize">
              <span>确认时间：{{ item.getMoneyTime }}</span>
            </div>
            <div class="d-flex justify-content-between fontSize">
              <span>创建时间：{{ item.creationTime }}</span>
            </div>
            <div class="buttons">
              <div
                class="book"
                @click.stop="tocode(item)"
                v-if="item.moneyCode !== null"
              >
                证明文书
              </div>
              <div
                class="jinzhan"
                @click.stop="tojinzhan(item)"
                v-if="item.businessUserId == item.userId && isBusinessUser()"
              >
                进展情况
              </div>
              <div
                class="tuihui"
                @click.stop="tuihui(item)"
                v-if="item.cancelRemark !== null"
              >
                退回原因
              </div>
              <div
                class="edit"
                @click.stop="edit(item)"
                v-if="
                  item.businessMobile != null &&
                  item.moneyCode == null &&
                  isSysAisBus()
                "
              >
                编辑
              </div>
              <div
                class="del"
                @click.stop="del(item.id)"
                v-if="
                  item.businessMobile != null &&
                  item.moneyCode == null &&
                  isSysAisBus()
                "
              >
                删除
              </div>
              <!-- 立项 -->
              <div
                class="lixiang"
                v-if="hasAudit(item) && isBusinessUser()"
                @click.stop="lixiang(item, '是否确认初审通过该线索？')"
              >
                {{ auditSucc(item.status) }}
              </div>
              <!-- 停止 -->
              <div
                class="tingzhi"
                v-if="hasAudit(item) && isBusinessUser()"
                @click.stop="tingzhi(item, '线索停止')"
              >
                {{ auditPass(item.status) }}
              </div>
            </div>
          </b-card>
        </b-col>
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="title">退回原因</div>
            <div class="remakecontent">{{ remake }}</div>
            <div class="yes" @click="yes">确定</div>
          </div>
        </div>
      </van-overlay>

      <van-dialog v-model="isxianshi" show-cancel-button @confirm="yes2">
        <div class="van-title">{{ font }}</div>
        <div class="van-row">
          <span>项目编号:</span>
          <span>{{ xiansuodata.projectNo }}</span>
        </div>
        <div class="van-row">
          <span>项目名称:</span>
          <span>{{ xiansuodata.projectName }}</span>
        </div>
        <div class="van-row">
          <span>企业名称:</span>
          <span>{{ xiansuodata.companyName }}</span>
        </div>
        <div class="van-row">
          <span>经办人:</span>
          <span>{{ xiansuodata.fullName }}</span>
        </div>
      </van-dialog>

      <van-dialog v-model="isxianshi2" show-cancel-button @confirm="yes3">
        <div class="van-title">{{ font }}</div>
        <div class="van-row">
          <span>项目编号:</span>
          <span>{{ tingzhidata.projectNo }}</span>
        </div>
        <div class="van-row">
          <span>项目名称:</span>
          <span>{{ tingzhidata.projectName }}</span>
        </div>
        <div class="van-row">
          <span>企业名称:</span>
          <span>{{ tingzhidata.companyName }}</span>
        </div>
        <div class="van-row">
          <span>经办人:</span>
          <span>{{ tingzhidata.fullName }}</span>
        </div>
      </van-dialog>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      xiansuodata: {},
      tingzhidata: {},
      font: "",
      isxianshi: false,
      isxianshi2: false,
      cluelist: [],
      remake: "",
      show: false,
      form: {
        total: 100,
        pageSize: 10,
        page: 1,
        //项目名称 || 编号
        Searchkey: "",
        //行业
        Industry: "",
        //项目性质
        NatureId: "",
        //联系人
        Contact: "",
        //状态
        Status: "",
        //用户id
        UserId: 0,
        Canye: "",
        //只看关注
        OnlyAttention: true,
        // 责任单位
        zrCompanyId: 0,
      },
    };
  },
  computed: {
    auditSucc() {
      return function (status) {
        return status == 11 ? "通过" : status == 15 ? "立项" : "通过";
      };
    },
    auditPass() {
      return function (status) {
        return "停止";
      };
    },
    hasAudit(args) {
      return function (row) {
        if (row.status == 11) {
          return row.carryUserId == row.optId;
        }
        if (row.status == 15) {
          return row.userId == row.optId;
        }
      };
    },
  },
  methods: {
    //立项
    lixiang(data, font) {
      console.log(data, 696);
      this.xiansuodata = data;
      this.isxianshi = true;
      this.font = font;
    },
    tingzhi(data, font) {
      this.tingzhidata = data;
      this.isxianshi2 = true;
      this.font = font;
    },
    isBusinessUser() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).currentUser.userType != 400
      );
    },
    isSysAisBus() {
      return (
        JSON.parse(
          localStorage.getItem("userInfo")
        ).currentUser.partDescription.indexOf("线索管理员") > -1 ||
        JSON.parse(
          localStorage.getItem("userInfo")
        ).currentUser.partDescription.indexOf("招商顾问") > -1
      );
    },
    iskeshi2() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).currentUser.userType == 400
      );
      // if (
      //   JSON.parse(localStorage.getItem("userInfo")).currentUser.userType == 400
      // ) {
      //   return true;
      // } else if (
      //   JSON.parse(
      //     localStorage.getItem("userInfo")
      //   ).currentUser.partDescription.indexOf("线索管理员") > -1 ||
      //   JSON.parse(localStorage.getItem("userInfo")).currentUser.userType == 300
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    // isdlx() {
    //   return (
    //     JSON.parse(
    //       localStorage.getItem("userInfo")
    //     ).currentUser.partDescription.indexOf("线索管理员") > -1 ||
    //     JSON.parse(
    //       localStorage.getItem("userInfo")
    //     ).currentUser.partDescription.indexOf("招商顾问") > -1
    //   );
    // },
    getcluelist() {
      this.request({
        url: "v1.0/Clues/getCluesNewList2",
        method: "GET",
        params: {
          Searchkey: this.form.Searchkey,
          Canye: this.form.Canye,
          Contact: this.form.Contact,
          NatureId: this.form.NatureId,
          Status: this.form.Status,
          PageSize: this.form.pageSize,
          PageIndex: this.form.page,
          ZrCompanyId: this.form.zrCompanyId,
        },
      }).then((res) => {
        console.log(res, 741);
        this.cluelist = res.data.items;
        console.log(this.cluelist, 77777);
        this.cluelist.forEach((item) => {
          console.log(this.isBusinessUser(), "pppppppppp");
          //默认就是待确认
          if (this.isBusinessUser()) {
            item.statusDescription = "待立项";
          } else {
            item.statusDescription = "待确认";
          }

          //
          if (item.moneyCode !== null) {
            item.statusDescription = "已采纳";
          }
          if (item.moneyCode !== null && item.businessUserId != item.userId) {
            item.statusDescription = "已分配";
          }
          if (item.cancelRemark) {
            item.statusDescription = "已退回";
          }

          item.getMoneyTime == null
            ? (item.getMoneyTime = "无")
            : item.getMoneyTime;
          if (item.isGetMoney == null) {
            console.log(1);
            this.$set(item, "isGetMoney", "未兑付");
          } else {
            this.$set(item, "isGetMoney", "已兑付");
          }
        });
      });
    },
    onItemClick(item) {
      console.log(item.id, 8888);
      this.$router.push(`/index/myclueDetail?data=${item.id}`);
    },
    tocode(item) {
      window.sessionStorage.setItem("order", JSON.stringify(item));
      this.$router.push(`/index/twocode?data=${item.id}`);
    },
    tojinzhan(item) {
      this.$router.push(`/index/programDetail?id=${item.id}`);
    },
    tuihui(item) {
      console.log(item, 777);
      this.show = true;
      this.remake = item.cancelRemark;
    },
    yes() {
      this.show = false;
    },
    //编辑
    edit(row) {
      window.localStorage.setItem("culeEidData", JSON.stringify(row));
      this.$router.push({
        name: "CluelistEdit",
      });
    },
    //删除
    del(id) {
      console.log(id);
      let data = {
        CluesId: id,
      };
      this.request({
        url: "/v1.0/Clues/deleteClues",
        method: "POST",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.$toast.success("线索已删除！");
          // toast(this, "线索已删除");
          this.getcluelist();
        } else {
          toast(this, res.message, "warning");
        }
      });
    },
    // 立项通过
    yes2() {
      let data = {
        cluesId: this.xiansuodata.id,
        userId: this.xiansuodata.userId,
        carryUserId: this.xiansuodata.carryUserId,
      };
      this.request({
        url: "/v1.0/Clues/cluesCheckPassed",
        method: "POST",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.$toast.success("审核成功");
          this.isxianshi = false;
          this.getcluelist();
        }
      });
    },
    //线索停止
    yes3() {
      let data = {
        carryUserId: this.tingzhidata.carryUserId,
        cluesId: this.tingzhidata.id,
        overruleStatus: 0,
        reson: " ",
        userId: this.tingzhidata.userId,
      };
      this.request({
        url: "/v1.0/Clues/cluesOverrule",
        method: "POST",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.$toast.success("审核成功");
          this.isxianshi2 = false;
          this.getcluelist();
        }
      });
    },
  },
  created() {
    this.getcluelist();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.ClueQuery {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
.list {
  margin-top: 8vh;
}
.van-pull-refresh {
  margin-top: 46px;
  height: calc(100% - 86px);
}
.buttons {
  display: flex;
  margin-top: 10px;
}
.book,
.lixiang {
  width: 60px;
  height: 20px;
  color: #ffffff;
  font-size: 12px;
  background: #4caf50;
  border-radius: 8px;
  text-align: center;
  line-height: 20px;
  margin-right: 10px;
}
.jinzhan,
.edit {
  width: 60px;
  height: 20px;
  color: #000000;
  font-size: 12px;
  background: #ffc107;
  border-radius: 8px;
  text-align: center;
  line-height: 20px;
  margin-right: 15px;
}
.del,
.tingzhi {
  width: 60px;
  height: 20px;
  color: #ffffff;
  font-size: 12px;
  background: #f44336;
  border-radius: 8px;
  text-align: center;
  line-height: 20px;
  margin-right: 15px;
}
.tuihui {
  background: #f44336;
  width: 60px;
  height: 20px;
  color: #ffffff;
  font-size: 12px;
  border-radius: 8px;
  text-align: center;
  line-height: 20px;
}
.card-body {
  padding-bottom: 10px;
}
// 遮罩层样式
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 60%;
  height: 200px;
  background-color: #fff;
  border-radius: 2px;
}

.title {
  text-align: center;
  margin-top: 10px;
}
.remakecontent {
  padding-left: 20px;
  margin-top: 30px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.yes {
  color: #fff;
  background-color: #409eff;
  width: 60px;
  height: 30px;
  text-align: center;
  margin: 0 auto;
  border-radius: 4px;
  line-height: 30px;
  margin-top: 50px;
}
.van-row {
  text-align: left;
  padding-left: 20px;
  margin-bottom: 20px;
}
.van-title {
  margin-bottom: 20px;
  text-align: center;
  margin-top: 15px;
}
</style>